import React, {FC} from 'react';

import {Trans} from '../../../libs/shared/core/src/helpers/internationalization/react';
import {Button} from '../../../libs/shared/ui/src/components/buttons/button';
import {ButtonVariantsEnum} from '../../../libs/shared/ui/src/components/buttons/buttonConstants';
import {GlobalKeyboardActionEventHandler} from '../../../libs/shared/ui/src/components/keyboard/keyboardContext';
import {KeyboardGlobalListener} from '../../../libs/shared/ui/src/components/keyboard/keyboardGlobalListener';
import {VisualSizesEnum} from '../../../libs/shared/ui/src/styles/commonStyles';
import {OnboardingTipTypesEnum} from '../../models/api/preferencesModel';
import {InfoBubble, InfoBubbleInstanceProps} from '../common/infoBubbles/infoBubble';
import {InfoBubbleContent} from '../common/infoBubbles/infoBubbleContent';
import {InfoBubbleDescription} from '../common/infoBubbles/infoBubbleContentDescription';
import {InfoBubbleTitle} from '../common/infoBubbles/infoBubbleContentTitle';
import {InfoBubbleFooterActions} from '../common/infoBubbles/infoBubbleFooterActions';
import {InfoBubblePill, InfoBubblePillVariantsEnum} from '../common/infoBubbles/infoBubblePill';
import {useOnboardingInfoBubblePresenter} from './onboardingInfoBubbleHook';

/*
 * Component.
 */

export const ReadStatusInfoBubble: FC<InfoBubbleInstanceProps> = ({anchor}) => {
  const {isVisible, closeInfoBubble: onClose} = useOnboardingInfoBubblePresenter(
    OnboardingTipTypesEnum.READ_STATUS_CELL,
  );
  const onRequestClose = () => {
    onClose([OnboardingTipTypesEnum.READ_STATUS_CELL, OnboardingTipTypesEnum.READ_STATUS_HIGHLIGHT]);
  };

  const onInterceptAction: GlobalKeyboardActionEventHandler = ({event}) => {
    event.preventDefault();
  };

  return (
    <InfoBubble
      position="right"
      anchor={anchor}
      isVisible={isVisible}
      isStandalone
      isInteractive
      interactionId="mark-as-read"
      onRequestClose={onRequestClose}
    >
      <KeyboardGlobalListener onInterceptAction={onInterceptAction} />
      <InfoBubbleContent>
        <InfoBubblePill type={InfoBubblePillVariantsEnum.EDUCATION} />
        <InfoBubbleTitle>
          <Trans id="infobubble-read-title">Messages will stay unread for your team</Trans>
        </InfoBubbleTitle>
        <InfoBubbleDescription>
          <Trans id="infobubble-read-description">
            When you read a conversation, it&apos;s only marked as read for you. It stays unread for your
            team.
          </Trans>
        </InfoBubbleDescription>
        <InfoBubbleFooterActions>
          <Button onClick={onRequestClose} size={VisualSizesEnum.MEDIUM} variant={ButtonVariantsEnum.PRIMARY}>
            <Trans id="infobubble-read-cta">Got it!</Trans>
          </Button>
        </InfoBubbleFooterActions>
      </InfoBubbleContent>
    </InfoBubble>
  );
};
